<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 w-full"
>
  <div class="flex gap-2 items-center">
    <div class="flex-1 flex gap-2 items-center">
      <ng-icon name="heroLifebuoy" size="20" class="!block" />
      <h2 class="leading-6 font-semibold">
        {{ 'cockpit.dashboard.helpCenterCard.title' | transloco }}
      </h2>
    </div>
    <ui-button
      mode="outlined"
      [iconOnly]="true"
      size="small"
      [routerLink]="['/help-center']"
      [attr.aria-label]="'cockpit.dashboard.helpCenterCard.title' | transloco"
    >
      <ng-icon name="heroArrowRight" size="20" class="!block" />
    </ui-button>
  </div>
  <ul class="flex flex-col gap-3">
    <li>
      <a
        [routerLink]="['/help-center', 'articles', 'locations']"
        fragment="section-add-location"
        class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md hover:border-primary/50 hover:bg-surface-variant/50 dark:hover:bg-surface-variant-darkmode/50 transition-colors group"
      >
        <ng-icon
          name="heroArrowTopRightOnSquare"
          size="20"
          class="!block text-on-surface-subtle dark:text-on-surface-subtle-darkmode group-hover:text-primary transition-colors shrink-0"
        />
        <span
          class="text-sm leading-5 line-clamp-1 text-on-surface dark:text-on-surface-darkmode group-hover:text-primary transition-colors"
        >
          {{ 'cockpit.dashboard.helpCenterCard.createLocations' | transloco }}
        </span>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/help-center', 'articles', 'energy-interfaces']"
        fragment="section-overview"
        class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md hover:border-primary/50 hover:bg-surface-variant/50 dark:hover:bg-surface-variant-darkmode/50 transition-colors group"
      >
        <ng-icon
          name="heroArrowTopRightOnSquare"
          size="20"
          class="!block text-on-surface-subtle dark:text-on-surface-subtle-darkmode group-hover:text-primary transition-colors shrink-0"
        />
        <span
          class="text-sm leading-5 line-clamp-1 text-on-surface dark:text-on-surface-darkmode group-hover:text-primary transition-colors"
        >
          {{ 'cockpit.dashboard.helpCenterCard.findEnergyInterfaces' | transloco }}
        </span>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/help-center']"
        class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md hover:border-primary/50 hover:bg-surface-variant/50 dark:hover:bg-surface-variant-darkmode/50 transition-colors group"
      >
        <ng-icon
          name="heroArrowTopRightOnSquare"
          size="20"
          class="!block text-on-surface-subtle dark:text-on-surface-subtle-darkmode group-hover:text-primary transition-colors shrink-0"
        />
        <span
          class="text-sm leading-5 line-clamp-1 text-on-surface dark:text-on-surface-darkmode group-hover:text-primary transition-colors"
        >
          {{ 'cockpit.dashboard.helpCenterCard.manageCustomerInfo' | transloco }}
        </span>
      </a>
    </li>
    <li>
      <a
        [routerLink]="['/help-center', 'articles', 'energy-interfaces']"
        fragment="section-management"
        class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md hover:border-primary/50 hover:bg-surface-variant/50 dark:hover:bg-surface-variant-darkmode/50 transition-colors group"
      >
        <ng-icon
          name="heroArrowTopRightOnSquare"
          size="20"
          class="!block text-on-surface-subtle dark:text-on-surface-subtle-darkmode group-hover:text-primary transition-colors shrink-0"
        />
        <span
          class="text-sm leading-5 line-clamp-1 text-on-surface dark:text-on-surface-darkmode group-hover:text-primary transition-colors"
        >
          {{ 'cockpit.dashboard.helpCenterCard.maloId' | transloco }}
        </span>
      </a>
    </li>
  </ul>
</div>
